import React, { PureComponent, Fragment } from 'react';

import { BaseColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';
import {
  CardAnalythic,
  RecommendationBox,
  RecommendationText,
  RecommendationsColumn,
  IconRecommendation,
  SpanRecommendation,
  RiskText
} from '../analythic.styled';
import FinancialConstraints from './financialConstraints/FinancialConstraints';
import CheckConstraints from './checkConstraints/CheckConstraints';
import Protest from './protest/Protest';
import AvoidConstraints from './avoidConstraints/AvoidConstraints';
import Block from '@bit/wavfichacerta.fichacerta.icons.block';
import ReportRecommendation from '@bit/wavfichacerta.fichacerta.icons.report-recommendation';
import Lawsuits from './lawsuits/Lawsuits';
import LawsuitsCriminais from './lawsuits/LawsuitsCriminais';
import LawsuitsCiveis from './lawsuits/LawsuitsCiveis';
import LawsuitsOutrosCnjReu from './lawsuits/LawsuitsOutrosCnjReu';
import LawsuitsOutrosCnjAutor from './lawsuits/LawsuitsOutrosCnjAutor';

import ReactTooltip from 'react-tooltip'
import TourTooltip from '../../../shared/TourTooltip';

export default class LocationSection extends PureComponent {
  state = {
    isVisibleCnjReu: false,
    isVisibleCnjAutor: false,
  }

  componentDidMount() {
    this.getDefaultVisibleCnjReu();
  }

  getRecommendations = () => {
    const { data } = this.props;

    if (data !== undefined && data !== null && (typeof data === "object" && Object.keys(data).length > 0)) {
      const searchKeys = ['restricoes_financeiras'];
      let recommendations = [];
      searchKeys.forEach((key) => {
        if (data[key] !== undefined && data[key] !== null) {
          recommendations = [...recommendations, ...data[key].recommendation];
        }
      });

      if (Array.isArray(recommendations) && recommendations.length > 0) {
        // Remove duplicates
        recommendations = recommendations.filter((rec, index) => recommendations.indexOf(rec) === index);
        return (
          <RecommendationBox>
            <BaseColumn xs={12} md={1} lg={1} xl={1}>
              <RecommendationText>Obs: </RecommendationText>
            </BaseColumn>
            <RecommendationsColumn xs={12} md={11} lg={11} xl={11}>
              {recommendations.map((item) => (
                <RecommendationText>
                  <IconRecommendation><ReportRecommendation /></IconRecommendation>
                  <SpanRecommendation>{item}</SpanRecommendation>
                </RecommendationText>
              ))}
            </RecommendationsColumn>
          </RecommendationBox>
        );
      }
    }
    return null;
  }

  handleVisibleCnjReu = async () => {
    const { data } = this.props;
    const pretendente = ("pretendente" in data)? data.pretendente : {};
    try {
      await this.props.updateVisibilyPretenderOthersCnj('reu', pretendente.id, !this.state.isVisibleCnjReu)
      this.setState({isVisibleCnjReu: !this.state.isVisibleCnjReu})
    } catch (err) {
      throw err;
    }
  }

  handleVisibleCnjAutor = async () => {
    const { data } = this.props;
    const pretendente = ("pretendente" in data)? data.pretendente : {};
    console.log('pret1', pretendente)
    try {
      await this.props.updateVisibilyPretenderOthersCnj('autor', pretendente.id, !this.state.isVisibleCnjAutor)
      this.setState({isVisibleCnjAutor: !this.state.isVisibleCnjAutor})
    } catch (err) {
      throw err;
    }
  }

  getDefaultVisibleCnjReu = async () => {
    const { data } = this.props;
    const pretendente = ("pretendente" in data)? data.pretendente : {};
    try {
      const result = await this.props.getVisibilyPretenderOthersCnj()
      const pretendentes = result.data ? result.data.pretendentes : [];
      let currentPretender = pretendentes.filter(pretender => pretender.id === pretendente.id)
      if(currentPretender.length) {
        this.setState({isVisibleCnjAutor: Boolean(currentPretender[0].visualizar_outras_acoes_cnj_autor), isVisibleCnjReu: Boolean(currentPretender[0].visualizar_outras_acoes_cnj_reu)})
      }
    } catch (err) {
      throw err;
    }
  }

  renderTextFcScoreMaisRecommendation = () => {
    const { data } = this.props;
    const laudo = ("laudo" in data)? data.laudo : {};
    const pretendente = ("pretendente" in data)? data.pretendente : {};
    const productFcScoreMais = pretendente.produtos.ativo.filter(produto => produto.id === 10 && produto.status !== 'INCLUIDO')
    const productComplementoReportMais = pretendente.produtos.ativo.filter(produto => produto.id === 12 && produto.status !== 'INCLUIDO')

    let temNegativacoes = false;

    if (
      laudo.restricoes_financeiras && (
        (laudo.restricoes_financeiras.result.cheques && laudo.restricoes_financeiras.result.cheques.info === 'CONSTA') ||
        (laudo.restricoes_financeiras.result.pendencias && laudo.restricoes_financeiras.result.pendencias.info === 'CONSTA') ||
        (laudo.restricoes_financeiras.result.protestos && laudo.restricoes_financeiras.result.protestos.info === 'CONSTA')
      )
    ) {
      temNegativacoes = true;
    }

    if(productFcScoreMais.length && productComplementoReportMais.length === 0 && temNegativacoes) {
      return (
        <>
          <RiskText style={{fontStyle: 'italic', fontSize: 11, fontWeight: 500, color: '#152b4e', marginTop: -12}}>*Para detalhamento consulte o Complemento do FC SCORE+.</RiskText>
        </>
      );
    }

    return null;
  }

  render() {
    const { data } = this.props;
    const laudo = ("laudo" in data)? data.laudo : {};
    const pretendente = ("pretendente" in data)? data.pretendente : {};
    const productFcReport = pretendente.produtos.ativo.filter(produto => produto.id === 1 && produto.status !== 'INCLUIDO')
    const productFcEssencial = pretendente.produtos.ativo.filter(produto => produto.id === 3)
    const productFcEmpresa = pretendente.produtos.ativo.filter(produto => produto.id === 4)
    const productFcBasico = pretendente.produtos.ativo.filter(produto => produto.id === 5)
    const productFcCompletaPF = pretendente.produtos.ativo.filter(produto => produto.id === 7 && produto.status !== 'INCLUIDO')
    const productFcCompletaPJ = pretendente.produtos.ativo.filter(produto => produto.id === 8 && produto.status !== 'INCLUIDO')
    const productFcScore = pretendente.produtos.ativo.filter(produto => produto.id === 9 && produto.status !== 'INCLUIDO')
    const productFcScoreMais = pretendente.produtos.ativo.filter(produto => produto.id === 10 && produto.status !== 'INCLUIDO')
    const productComplementoReport = pretendente.produtos.ativo.filter(produto => produto.id === 11 && produto.status !== 'INCLUIDO')
    const productComplementoReportMais = pretendente.produtos.ativo.filter(produto => produto.id === 12 && produto.status !== 'INCLUIDO')
    let isPJ = false;
    const clientId = data.extra.client_id;

    if (productFcEssencial.length && !productFcReport.length) return null;

    let temFcBasicoSemReport = false;

    if(productFcBasico.length && !productFcReport.length) {
      temFcBasicoSemReport = true;
    }

    if(productFcEmpresa.length || productFcCompletaPJ.length) {
      isPJ = true;
    }

    let temAcoes = false;

    if (
      laudo.restricoes_financeiras && (
        (laudo.restricoes_financeiras.result.acoes && laudo.restricoes_financeiras.result.acoes.info === 'CONSTA') ||
        (laudo.restricoes_financeiras.result.acoes_criminais && laudo.restricoes_financeiras.result.acoes_criminais.info === 'CONSTA') ||
        (laudo.restricoes_financeiras.result.acoes_outros_cnj_autor && laudo.restricoes_financeiras.result.acoes_outros_cnj_autor.info === 'CONSTA') ||
        (laudo.restricoes_financeiras.result.acoes_outros_cnj_reu && laudo.restricoes_financeiras.result.acoes_outros_cnj_reu.info === 'CONSTA')
      )
    ) {
      temAcoes = true;
    }


    let acoesDesabilitadas = false;

    // essa condicao faz parte do report_settings do cliente, para nao exibir a parte de acoes caso todas as ações estejam desabilitadas
    if(laudo.restricoes_financeiras && !('acoes' in laudo.restricoes_financeiras.result) && !('acoes_criminais' in laudo.restricoes_financeiras.result) && !('acoes_outros_cnj_autor' in laudo.restricoes_financeiras.result) && !('acoes_outros_cnj_reu' in laudo.restricoes_financeiras.result)) {
      acoesDesabilitadas = true;
    }

    const fcScoreSemComplemento = productFcScore.length && productComplementoReport.length === 0 ? true : false;
    const fcScoreMaisSemComplemento = productFcScoreMais.length && productComplementoReportMais.length === 0 ? true : false;

    return (
      <Fragment>
        {(productFcScore.length && productComplementoReport.length === 0) && (clientId !== 228947 && clientId !== 39931) ? null : // TODO: remover essa condição quando o cliente 228947 "Produção" o Id 39931 "staging" (CREDITO REAL) não usar mais o FC Score ou quando for feito a configuração de laudo por produto do cliente
          <CardAnalythic
            title="NEGATIVAÇÕES DE CRÉDITO*"
            iconHeader={Block}
            iconLeft={true}
            className={`data-p-${data.pretendente.id} ${!isPJ && 'negativacoes-credito-pf'}`}
          >
            <AvoidConstraints dataSource={this.props.data.laudo} />
            <FinancialConstraints dataSource={this.props.data.laudo} pretendente={pretendente} fcScoreSemComplemento={fcScoreSemComplemento} fcScoreMaisSemComplemento={fcScoreMaisSemComplemento} />
            <CheckConstraints dataSource={this.props.data.laudo} fcScoreSemComplemento={fcScoreSemComplemento} fcScoreMaisSemComplemento={fcScoreMaisSemComplemento} />
            <Protest dataSource={this.props.data.laudo} fcScoreSemComplemento={fcScoreSemComplemento} fcScoreMaisSemComplemento={fcScoreMaisSemComplemento} />
            {/* <Lawsuits dataSource={this.props.data.laudo} pretendente={pretendente} temFcBasicoSemReport={temFcBasicoSemReport} />
            {(productFcEssencial.length || productFcReport.length || productFcBasico.length || productFcCompletaPF.length || productFcCompletaPJ.length) &&
              <LawsuitsCriminais dataSource={this.props.data.laudo} pretendente={pretendente} temFcBasicoSemReport={temFcBasicoSemReport} /> || null
            }
            {(productFcReport.length || productFcBasico.length || productFcEmpresa.length || productFcCompletaPF.length || productFcCompletaPJ.length) &&
              <LawsuitsCiveis dataSource={this.props.data.laudo} temFcBasicoSemReport={temFcBasicoSemReport} /> || null
            }
            {(productFcReport.length || productFcEmpresa.length || productFcCompletaPF.length || productFcCompletaPJ.length) &&
              <LawsuitsOutrosCnjReu dataSource={this.props.data.laudo} pretendente={pretendente} handleVisibleCnjReu={this.handleVisibleCnjReu} isVisibleCnjReu={this.state.isVisibleCnjReu} isPJ={isPJ} /> || null
            }
            {(productFcReport.length || productFcEmpresa.length || productFcCompletaPF.length || productFcCompletaPJ.length) &&
              <LawsuitsOutrosCnjAutor dataSource={this.props.data.laudo} pretendente={pretendente} handleVisibleCnjAutor={this.handleVisibleCnjAutor} isVisibleCnjAutor={this.state.isVisibleCnjAutor} isPJ={isPJ} /> || null
            } */}
            <RiskText style={{fontStyle: 'italic', fontSize: 11, fontWeight: 500, color: '#152b4e'}}>*Buscas automatizadas que dependem da disponibilidade das fontes. Podem não refletir a totalidade de apontamentos do pesquisado. Buscas realizadas por {productFcEmpresa.length || productFcCompletaPJ.length ? 'CNPJ' : 'CPF'}, embora não seja afastada a possibilidade de homonimias. <span style={{color: '#fe4d36'}}>{this.props.data.laudo.restricoes_financeiras && this.props.data.laudo.restricoes_financeiras.alerta_acoes_riogrande_do_sul}</span></RiskText>
            {this.renderTextFcScoreMaisRecommendation()}
            {this.getRecommendations()}
            {/* <TourTooltip
              target="tooltip-informacoes-restritivas"
              style={{right: -3, top: -17}}
            />
            <ReactTooltip id="tooltip-informacoes-restritivas" place="left" type="dark" effect="float">
              <span>Confira abaixo o detalhamento de eventuais informações restritivas detectadas.</span>
            </ReactTooltip> */}
          </CardAnalythic>
        }

        {((productFcScore.length) && productComplementoReport.length === 0) || acoesDesabilitadas === true ? null :
          <CardAnalythic
            title="AÇÕES JUDICIAIS*"
            iconHeader={Block}
            iconLeft={true}
            className={`data-p-${data.pretendente.id} ${!isPJ && 'acoes-judiciais-pf'}`}
          >
            {/* <AvoidConstraints dataSource={this.props.data.laudo} />
            <FinancialConstraints dataSource={this.props.data.laudo} pretendente={pretendente} />
            <CheckConstraints dataSource={this.props.data.laudo} />
            <Protest dataSource={this.props.data.laudo} /> */}
            <RiskText style={{fontStyle: 'italic', fontSize: 11, fontWeight: 500, color: '#152b4e', paddingBottom: 4}}>*Buscas automatizadas que dependem da disponibilidade das fontes. Podem não refletir a totalidade de apontamentos do pesquisado. Buscas realizadas por {productFcEmpresa.length || productFcCompletaPJ.length ? 'CNPJ' : 'CPF'}, embora não seja afastada a possibilidade de homonimias. <span style={{color: '#fe4d36'}}>{this.props.data.laudo.restricoes_financeiras && this.props.data.laudo.restricoes_financeiras.alerta_acoes_riogrande_do_sul}</span></RiskText>
            {temAcoes && <RiskText style={{fontStyle: 'italic', fontSize: 11, fontWeight: 500, color: '#fe4d36', display: 'block', textDecoration: 'underline', paddingTop: 0}}><b>As ações judiciais apuradas possuem caráter informativo, e podem impactar a análise de risco, dependendo da sua natureza e gravidade. Recomenda-se que sejam avaliadas com apoio jurídico para determinar sua real relevância para a locação.</b></RiskText>}
            <Lawsuits dataSource={this.props.data.laudo} pretendente={pretendente} temFcBasicoSemReport={temFcBasicoSemReport} />
            {(productFcEssencial.length || productFcReport.length || productFcBasico.length || productFcCompletaPF.length || productFcCompletaPJ.length || productFcScoreMais.length || productComplementoReport.length || productComplementoReportMais.length) &&
              <LawsuitsCriminais dataSource={this.props.data.laudo} pretendente={pretendente} temFcBasicoSemReport={temFcBasicoSemReport} /> || null
            }
            {(productFcReport.length || productFcBasico.length || productFcEmpresa.length || productFcCompletaPF.length || productFcCompletaPJ.length || productFcScoreMais.length || productComplementoReport.length || productComplementoReportMais.length) &&
              <LawsuitsCiveis dataSource={this.props.data.laudo} temFcBasicoSemReport={temFcBasicoSemReport} /> || null
            }
            {(productFcReport.length || productFcEmpresa.length || productFcCompletaPF.length || productFcCompletaPJ.length || productFcScoreMais.length || productComplementoReport.length || productComplementoReportMais.length) &&
              <LawsuitsOutrosCnjReu dataSource={this.props.data.laudo} pretendente={pretendente} handleVisibleCnjReu={this.handleVisibleCnjReu} isVisibleCnjReu={this.state.isVisibleCnjReu} isPJ={isPJ} /> || null
            }
            {(productFcReport.length || productFcEmpresa.length || productFcCompletaPF.length || productFcCompletaPJ.length || productFcScoreMais.length || productComplementoReport.length || productComplementoReportMais.length) &&
              <LawsuitsOutrosCnjAutor dataSource={this.props.data.laudo} pretendente={pretendente} handleVisibleCnjAutor={this.handleVisibleCnjAutor} isVisibleCnjAutor={this.state.isVisibleCnjAutor} isPJ={isPJ} /> || null
            }
            {this.getRecommendations()}
            {/* <TourTooltip
              target="tooltip-informacoes-restritivas"
              style={{right: -3, top: -17}}
            />
            <ReactTooltip id="tooltip-informacoes-restritivas" place="left" type="dark" effect="float">
              <span>Confira abaixo o detalhamento de eventuais informações restritivas detectadas.</span>
            </ReactTooltip> */}
          </CardAnalythic>
        }
      </Fragment>
    );
  }
}
